import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

@Feature()
export class EditFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    public setFocus() {
        const model = this.getSelectionService().selectedElements.getCurrentModel();
        if (model.type === UIModelType.TABLE) {
            model.enterFirstCell?.();
        }
        if (model?.isPlaceholder) {
            const enterPlaceHolderEvent = new CustomEvent('enterPlaceHolder', {
                detail: model,
            });
            window.dispatchEvent(enterPlaceHolderEvent);
        } else {
            model?.editorInstance?.setFocus?.();
        }
    }
}
